import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import Submissions from '../components/instructor/Submissions'

const SubmissionsPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <Submissions/>
    </>
  )
}

export default SubmissionsPage